import { render, staticRenderFns } from "./Allegato.vue?vue&type=template&id=011cf153&"
import script from "./Allegato.vue?vue&type=script&lang=js&"
export * from "./Allegato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports